export default __webpack_public_path__ + "static/media/home-about-us-2.2def2260.jpeg";